const TOURNAMENT_MEMBER_STATUS = {
  waited: 1,
  transfered: 2,
  ended: 3,
};

const TOURNAMENT_MEMBER_ACTIONS = {
  transfer: 1,
  finish: 2,
  remove: 3,
  resume: 4,
};

export default {
  TOURNAMENT_MEMBER_STATUS,
  TOURNAMENT_MEMBER_ACTIONS,
};
